import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_board',
      component: Index,
      meta: {
        featureFlag: FEATURE_FLAGS.KANBAN,
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
